import { css } from 'styled-components';

import { TButtonProps } from '@r1-frontend/ui-kit/atoms/button';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

const getResponsiveSizeStyles = () => ({ theme, $small = false, icon, children }: ThemedProperties<TButtonProps & { children?: unknown }>) => {
    const hasIconOnly = !!icon && !children;

    if ($small) {
        return css`
            font-size: ${theme.typography.headers.h5.mobile.fs}px;
            line-height: ${theme.typography.headers.h5.mobile.lh}px;
            padding: ${hasIconOnly ? `${theme.indents.xxs}px` : `${theme.indents.xxs}px ${theme.indents.s}px`};
        `;
    }

    return css`
        font-size: ${theme.typography.headers.h5.mobile.fs}px;
        line-height: ${theme.typography.headers.h5.mobile.lh}px;
        padding: ${hasIconOnly ? `${theme.indents.xs}px` : `${theme.indents.xs}px ${theme.indents.xm}px`};

        @media (min-width: ${theme.breakpoints.tablet}) {
            font-size: ${theme.typography.headers.h5.desktop.fs}px;
            line-height: ${theme.typography.headers.h5.desktop.lh}px;
        }
    `;
};

export default getResponsiveSizeStyles;
